<div class="page-container">
  <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onLagerChange($event)" class="lager-tabs">
    <mat-tab *ngFor="let lagerItem of lager">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">warehouse</mat-icon>
        <span>{{ lagerItem }}</span>
      </ng-template>

      <div class="content-wrapper">

        <!-- Toolbar -->
        <div class="toolbar">
          <div class="toolbar-left">
            <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput
                     [formControl]="filterControl"
                     placeholder="Teile suchen..."
                     [matAutocomplete]="searchAuto">
              <button *ngIf="filterControl.value" mat-icon-button matSuffix (click)="filterControl.setValue('')" aria-label="Suche leeren">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #searchAuto="matAutocomplete"
                                (optionSelected)="onSuggestionSelected($event.option.value)"
                                class="search-autocomplete">
                <mat-option *ngFor="let suggestion of searchSuggestions" [value]="suggestion">
                  <mat-icon class="suggestion-icon">search</mat-icon>
                  <span>{{ suggestion }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="category-field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Kategorie</mat-label>
              <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange($event.value)">
                <mat-option *ngFor="let category of categories" [value]="category">
                  {{ category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="toolbar-right">
            <button mat-icon-button
                    class="toolbar-btn"
                    (click)="toggleAdvancedFilters()"
                    [class.active]="showAdvancedFilters"
                    matTooltip="Erweiterte Filter">
              <mat-icon>tune</mat-icon>
            </button>

            <button mat-icon-button
                    class="toolbar-btn"
                    (click)="deleteFilter()"
                    matTooltip="Filter zurücksetzen">
              <mat-icon>filter_alt_off</mat-icon>
            </button>

            <button mat-icon-button
                    class="toolbar-btn view-toggle"
                    (click)="toggleViewManually()"
                    matTooltip="Ansicht umschalten">
              <mat-icon>{{ viewMode === 'table' ? 'grid_view' : 'view_list' }}</mat-icon>
            </button>

            <button mat-flat-button
                    color="primary"
                    class="add-btn"
                    *ngIf="canEdit"
                    (click)="onAddClick()">
              <mat-icon>add</mat-icon>
              <span class="add-btn-text">Hinzufügen</span>
            </button>
          </div>
        </div>

        <!-- Erweiterte Filter -->
        <div class="advanced-filters" *ngIf="showAdvancedFilters" @slideDown>
          <div class="advanced-filters-grid">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Hersteller</mat-label>
              <input matInput [(ngModel)]="advancedFilters.hersteller" placeholder="Hersteller">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Lagerort</mat-label>
              <mat-select (selectionChange)="applyLagerortFilter($event.value)">
                <mat-option [value]="">Alle</mat-option>
                <mat-option *ngFor="let location of lagerort" [value]="location">
                  {{ location }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filter-actions">
            <button mat-button (click)="resetAdvancedFilters(); applyAdvancedFilters();">Zurücksetzen</button>
            <button mat-flat-button color="primary" (click)="applyAdvancedFilters()">
              <mat-icon>check</mat-icon> Anwenden
            </button>
          </div>
        </div>

        <!-- Loading overlay -->
        <div *ngIf="isLoading" class="loading-overlay">
          <div class="loading-spinner">
            <mat-progress-spinner mode="indeterminate" diameter="44" color="primary"></mat-progress-spinner>
            <span>Daten werden geladen...</span>
          </div>
        </div>

        <!-- === TABELLENANSICHT === -->
        <div *ngIf="viewMode === 'table'" class="table-card" [class.dimmed]="isLoading">
          <table mat-table [dataSource]="dataSource" class="elements-table">

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="col-header" (click)="sortByColumn('name')">
                Name
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'name'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell col-name">
                <span class="element-name" [matTooltip]="element.name">{{ element.name }}</span>
                <span class="element-sub">{{ element.kategorie }}</span>
              </td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef class="col-header hide-md" (click)="sortByColumn('description')">
                Beschreibung
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'description'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell hide-md">
                <span class="cell-truncate" [matTooltip]="element.description">{{ element.description }}</span>
              </td>
            </ng-container>

            <!-- Hersteller Column -->
            <ng-container matColumnDef="hersteller">
              <th mat-header-cell *matHeaderCellDef class="col-header hide-md" (click)="sortByColumn('hersteller')">
                Hersteller
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'hersteller'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell hide-md">
                <span class="cell-truncate" [matTooltip]="element.hersteller">{{ element.hersteller }}</span>
              </td>
            </ng-container>

            <!-- Kategorie Column -->
            <ng-container matColumnDef="kategorie">
              <th mat-header-cell *matHeaderCellDef class="col-header hide-sm" (click)="sortByColumn('kategorie')">
                Kategorie
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'kategorie'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell hide-sm">
                <span class="badge-category">{{ element.kategorie }}</span>
              </td>
            </ng-container>

            <!-- Bestellnummer Column -->
            <ng-container matColumnDef="bestellnumer">
              <th mat-header-cell *matHeaderCellDef class="col-header hide-lg" (click)="sortByColumn('bestellnumer')">
                Bestellnr.
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'bestellnumer'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell hide-lg">
                <span class="cell-mono cell-truncate" [matTooltip]="element.bestellnumer">{{ element.bestellnumer }}</span>
              </td>
            </ng-container>

            <!-- Lager/Lagerort Column -->
            <ng-container matColumnDef="lager_lagerort">
              <th mat-header-cell *matHeaderCellDef class="col-header hide-lg" (click)="sortByColumn('lager_lagerort')">
                Lagerort
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'lager_lagerort'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell hide-lg">
                <span class="cell-location" [matTooltip]="element.lager_lagerort">
                  <mat-icon class="loc-icon">place</mat-icon>
                  <span class="cell-truncate">{{ element.lager_lagerort }}</span>
                </span>
              </td>
            </ng-container>

            <!-- Quantity Column -->
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef class="col-header col-qty-header" (click)="sortByColumn('quantity')">
                Menge
                <mat-icon class="sort-arrow" *ngIf="sortActive === 'quantity'">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let element" class="col-cell col-qty">
                <ng-container *ngIf="element.editMode; else qtyView">
                  <mat-form-field class="edit-qty-field" appearance="outline" subscriptSizing="dynamic">
                    <input matInput type="number" [(ngModel)]="element.quantity">
                  </mat-form-field>
                </ng-container>
                <ng-template #qtyView>
                  <span class="qty-badge" [class.qty-low]="element.quantity <= 5" [class.qty-zero]="element.quantity <= 0">
                    {{ element.quantity }}
                  </span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="col-header col-actions-header"></th>
              <td mat-cell *matCellDef="let element" class="col-cell col-actions">
                <div class="row-actions">
                  <button mat-stroked-button
                          color="primary"
                          class="action-withdraw"
                          (click)="openWithdrawalDialog(element)"
                          matTooltip="Element entnehmen">
                    <mat-icon>shopping_cart_checkout</mat-icon>
                    <span class="action-label">Entnehmen</span>
                  </button>
                  <button mat-icon-button
                          class="action-icon-btn"
                          *ngIf="canEdit"
                          (click)="openEditDialog(element,false)"
                          matTooltip="Bearbeiten">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button
                          class="action-icon-btn"
                          *ngIf="canEdit"
                          (click)="openEditDialog(element,true)"
                          matTooltip="Kopieren">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button mat-icon-button
                          class="action-icon-btn action-delete"
                          *ngIf="canEdit"
                          (click)="onDeleteClick(element)"
                          matTooltip="Löschen">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- Edit Quantity (hidden column kept for compatibility) -->
            <ng-container matColumnDef="editQuantity">
              <th mat-header-cell *matHeaderCellDef class="col-header" style="display:none"></th>
              <td mat-cell *matCellDef="let element" class="col-cell" style="display:none"></td>
            </ng-container>

            <!-- Table Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="table-head-row"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-data-row"></tr>

            <!-- No Data -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                <div class="empty-state">
                  <mat-icon>inventory_2</mat-icon>
                  <h3>Keine Elemente gefunden</h3>
                  <p>Passe deine Filterkriterien an oder füge neue Elemente hinzu.</p>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <!-- === KARTENANSICHT === -->
        <div *ngIf="viewMode === 'card'" class="cards-grid" [class.dimmed]="isLoading">
          <div *ngFor="let element of dataSource.data" class="element-card">
            <div class="card-top">
              <div class="card-info">
                <h3 class="card-title">{{ element.name }}</h3>
                <span class="card-category">{{ element.kategorie }}</span>
              </div>
              <div class="card-qty" [class.qty-low]="element.quantity <= 5" [class.qty-zero]="element.quantity <= 0">
                {{ element.quantity }}
              </div>
            </div>

            <div class="card-details">
              <div class="detail-row" *ngIf="element.description" [matTooltip]="element.description">
                <mat-icon>description</mat-icon>
                <span class="detail-text">{{ element.description }}</span>
              </div>
              <div class="detail-row" *ngIf="element.hersteller" [matTooltip]="element.hersteller">
                <mat-icon>factory</mat-icon>
                <span class="detail-text">{{ element.hersteller }}</span>
              </div>
              <div class="detail-row" *ngIf="element.bestellnumer" [matTooltip]="element.bestellnumer">
                <mat-icon>tag</mat-icon>
                <span class="detail-text cell-mono">{{ element.bestellnumer }}</span>
              </div>
              <div class="detail-row" *ngIf="element.lager_lagerort" [matTooltip]="element.lager_lagerort">
                <mat-icon>place</mat-icon>
                <span class="detail-text">{{ element.lager_lagerort }}</span>
              </div>
            </div>

            <div class="card-actions">
              <button mat-flat-button color="primary" class="card-withdraw-btn" (click)="openWithdrawalDialog(element)">
                <mat-icon>shopping_cart_checkout</mat-icon>
                Entnehmen
              </button>
              <div class="card-secondary-actions" *ngIf="canEdit">
                <button mat-icon-button (click)="openEditDialog(element,false)" matTooltip="Bearbeiten">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="openEditDialog(element,true)" matTooltip="Kopieren">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="action-delete" (click)="onDeleteClick(element)" matTooltip="Löschen">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div *ngIf="dataSource.data.length === 0" class="empty-state-card">
            <mat-icon>inventory_2</mat-icon>
            <h3>Keine Elemente gefunden</h3>
            <p>Passe deine Filterkriterien an oder füge neue Elemente hinzu.</p>
          </div>
        </div>

        <!-- Paginator -->
        <mat-paginator #paginator
                       [length]="totalCount"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="[10, 18, 50, 100]"
                       [pageIndex]="currentPage - 1"
                       (page)="onPageChange($event)"
                       showFirstLastButtons
                       class="paginator">
        </mat-paginator>

      </div>
    </mat-tab>
  </mat-tab-group>
</div>
